import React, { useEffect, useState } from "react";
import "./Gallery.css";
import { API_BASE_URL } from "../config";

const API_BASE = `${API_BASE_URL}/admin/gallery`;

export default function Gallery() {
  const [rpcImages, setRpcImages] = useState([]);
  const [fpvImages, setFpvImages] = useState([]);
  const [mappingImages, setMappingImages] = useState([]);

  useEffect(() => {
    fetch(API_BASE)
      .then((res) => res.json())
      .then((data) => {
        if (!Array.isArray(data)) return;

        setRpcImages(data.filter((f) => f?.category === "rpc"));
        setFpvImages(data.filter((f) => f?.category === "fpv"));
        setMappingImages(data.filter((f) => f?.category === "mapping"));
      })
      .catch(console.error);
  }, []);

  const renderSlider = (title, description, list = []) => {
    if (!Array.isArray(list) || list.length === 0) return null;

    return (
      <div className="gallery-category-container">
        <div className="gallery-category-header">
          <h2 className="gallery-category-title">{title}</h2>
          <p className="gallery-category-desc">{description}</p>
        </div>

        <div className="gallery-slider-wrapper">
          {/* Decorative background blur */}
          <div className="gallery-glow-bg"></div>

          <div className="gallery-slider">
            <div className="gallery-track">
              {/* Duplicate list to create an infinite ribbon scroll effect */}
              {[...list, ...list].map((img, i) => (
                <div className="gallery-item" key={img._id ? `${img._id}-${i}` : i}>
                  <div className="gallery-img-container">
                    <img
                      src={`${API_BASE_URL}${img.url}`}
                      alt={img.filename || title}
                      loading="lazy"
                    />
                    <div className="gallery-img-overlay">
                      <span className="gallery-overlay-icon">✦</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <section className="gallery-page-section">
      {/* Dynamic Background Pattern */}
      <div className="gallery-bg-pattern"></div>

      <div className="gallery-hero-container">
        <div className="gallery-heading-badge">Our Visual Showcase</div>
        <h1 className="gallery-hero-title">Experience the Excellence</h1>
        <p className="gallery-hero-subtitle">
          A visual journey through our premier drone operations, cutting-edge FPV training, and advanced aerial mapping capabilities.
        </p>
      </div>

      <div className="gallery-content-wrapper">
        {renderSlider(
          "RPC Training Operations",
          "Glimpses into our comprehensive Remote Pilot Certificate training modules.",
          rpcImages
        )}
        {renderSlider(
          "FPV Drone Dynamics",
          "High-speed precision flying and custom-built FPV drone maneuvers.",
          fpvImages
        )}
        {renderSlider(
          "Advanced Aerial Mapping",
          "Professional-grade topographical surveys and 3D modeling captures.",
          mappingImages
        )}
      </div>
    </section>
  );
}
